module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"name":{"label":"Name"},"email":{"label":"Email"},"message":{"label":"What do you need help with?"},"button":"Send request","whatsapp":"Send on Whatsapp"},"nl":{"name":{"label":"Naam"},"email":{"label":"E-mailadres"},"message":{"label":"Waar heb je ons voor nodig?"},"button":"Aanvraag verzenden","whatsapp":"Stuur via Whatsapp"}}')
  delete Component.options._Ctor
}
